export default __webpack_public_path__ + "static/table-4bba1c7383cc72bfee52ac4596195ba5.png";